/* OXWAYİ — theme.js */
(function () {
  'use strict';

  const drawerSection = 'cart-drawer';

  function drawer() { return document.getElementById('CartDrawer'); }

  function openDrawer() {
    const d = drawer();
    if (!d) { window.location.href = window.routes.cart; return; }
    d.classList.add('is-open');
    d.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    const close = d.querySelector('[data-drawer-close]');
    if (close) close.focus();
  }

  function closeDrawer() {
    const d = drawer();
    if (!d) return;
    d.classList.remove('is-open');
    d.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  function updateCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = count > 0 ? count : '';
      el.setAttribute('data-count', count);
    });
  }

  function renderDrawer(html) {
    const d = drawer();
    if (!d || !html) return;
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const fresh = doc.querySelector('[data-drawer-inner]');
    const current = d.querySelector('[data-drawer-inner]');
    if (fresh && current) current.replaceWith(fresh);
  }

  function refreshDrawer() {
    return fetch(window.routes.root + '?sections=' + drawerSection)
      .then(function (r) { return r.json(); })
      .then(function (data) { renderDrawer(data[drawerSection]); })
      .then(function () { return fetch(window.routes.cart + '.js'); })
      .then(function (r) { return r.json(); })
      .then(function (cart) { updateCount(cart.item_count); });
  }

  /* Add to cart ------------------------------------------------------- */
  document.addEventListener('submit', function (e) {
    const form = e.target.closest('form[data-product-form]');
    if (!form) return;
    e.preventDefault();
    const btn = form.querySelector('[type="submit"]');
    const msg = form.querySelector('[data-form-message]');
    if (msg) msg.textContent = '';
    if (btn) { btn.setAttribute('disabled', ''); btn.dataset.label = btn.dataset.label || btn.innerHTML; btn.innerHTML = 'Ekleniyor…'; }

    fetch(window.routes.cart_add + '.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: new FormData(form)
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, json: j }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error(res.json.description || res.json.message || 'Ürün sepete eklenemedi.');
        return refreshDrawer().then(openDrawer);
      })
      .catch(function (err) { if (msg) msg.textContent = err.message; })
      .finally(function () { if (btn) { btn.removeAttribute('disabled'); btn.innerHTML = btn.dataset.label; } });
  });

  /* Drawer line changes ---------------------------------------------- */
  function changeLine(line, quantity) {
    const d = drawer();
    if (d) d.classList.add('is-loading');
    return fetch(window.routes.cart_change + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: Number(line), quantity: Math.max(0, quantity) })
    })
      .then(function () { return refreshDrawer(); })
      .finally(function () { if (d) d.classList.remove('is-loading'); });
  }

  document.addEventListener('click', function (e) {
    const opener = e.target.closest('[data-drawer-open]');
    if (opener && drawer()) { e.preventDefault(); openDrawer(); return; }

    if (e.target.closest('[data-drawer-close]')) { e.preventDefault(); closeDrawer(); return; }

    const step = e.target.closest('[data-qty-step]');
    if (step) {
      const wrap = step.closest('[data-qty]');
      const input = wrap && wrap.querySelector('input');
      if (!input) return;
      e.preventDefault();
      const min = Number(input.min || 0);
      const next = Math.max(min, (Number(input.value) || 0) + Number(step.dataset.qtyStep));
      input.value = next;
      if (wrap.hasAttribute('data-line')) changeLine(wrap.dataset.line, next);
      else input.dispatchEvent(new Event('change', { bubbles: true }));
      return;
    }

    const remove = e.target.closest('[data-line-remove]');
    if (remove) { e.preventDefault(); changeLine(remove.dataset.lineRemove, 0); return; }

    const thumb = e.target.closest('[data-thumb]');
    if (thumb) {
      const gallery = thumb.closest('[data-gallery]');
      const main = gallery && gallery.querySelector('[data-gallery-main] img');
      if (main) {
        main.src = thumb.dataset.thumb;
        main.removeAttribute('srcset');
        gallery.querySelectorAll('[data-thumb]').forEach(function (t) { t.setAttribute('aria-current', t === thumb ? 'true' : 'false'); });
      }
    }
  });

  document.addEventListener('change', function (e) {
    const input = e.target.closest('[data-line] input');
    if (input) changeLine(input.closest('[data-line]').dataset.line, Number(input.value));

    const sel = e.target.closest('[data-variant-select]');
    if (sel) {
      const opt = sel.options[sel.selectedIndex];
      const scope = sel.closest('[data-product-scope]');
      if (!scope || !opt) return;
      const priceEl = scope.querySelector('[data-price-current]');
      const compareEl = scope.querySelector('[data-price-compare]');
      const btn = scope.querySelector('[data-product-form] [type="submit"]');
      if (priceEl) priceEl.textContent = opt.dataset.price;
      if (compareEl) { compareEl.textContent = opt.dataset.compare || ''; compareEl.hidden = !opt.dataset.compare; }
      if (btn) {
        const available = opt.dataset.available === 'true';
        btn.disabled = !available;
        btn.innerHTML = available ? (btn.dataset.addLabel || 'Sepete ekle') : 'Tükendi';
        btn.dataset.label = btn.innerHTML;
      }
      if (opt.dataset.image) {
        const main = scope.querySelector('[data-gallery-main] img');
        if (main) { main.src = opt.dataset.image; main.removeAttribute('srcset'); }
      }
    }
  });

  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });

  /* Sticky add to cart ------------------------------------------------ */
  document.addEventListener('DOMContentLoaded', function () {
    const sticky = document.querySelector('[data-sticky-atc]');
    const target = document.querySelector('[data-sticky-target]');
    if (sticky && target && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          const passed = !en.isIntersecting && en.boundingClientRect.top < 0;
          sticky.classList.toggle('is-visible', passed);
        });
      }).observe(target);
      const btn = sticky.querySelector('button');
      if (btn) btn.addEventListener('click', function () {
        const form = target.closest('form') || document.querySelector('form[data-product-form]');
        if (form) form.requestSubmit();
      });
    }

    /* Reveal on scroll */
    const items = document.querySelectorAll('.reveal');
    if ('IntersectionObserver' in window) {
      const io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
      }, { rootMargin: '0px 0px -8% 0px' });
      items.forEach(function (el) { io.observe(el); });
    } else {
      items.forEach(function (el) { el.classList.add('is-in'); });
    }
  });

  /* Theme editor support */
  document.addEventListener('shopify:section:load', function () {
    document.querySelectorAll('.reveal').forEach(function (el) { el.classList.add('is-in'); });
  });
})();

/* Bundle picker */
(function () {
  function applyBundle(radio) {
    const scope = radio.closest('[data-product-scope]') || document;
    const form = scope.querySelector('form[data-product-form]');
    if (!form) return;
    let qty = form.querySelector('input[name="quantity"]');
    if (!qty) {
      qty = document.createElement('input');
      qty.type = 'hidden'; qty.name = 'quantity';
      form.appendChild(qty);
    }
    qty.value = radio.dataset.bundleQty || 1;
    const vid = radio.dataset.bundleVariant;
    if (vid) {
      const idField = form.querySelector('[name="id"]');
      if (idField) idField.value = vid;
    }
    const sticky = document.querySelector('[data-sticky-price]');
    if (sticky && radio.dataset.bundlePrice) sticky.textContent = radio.dataset.bundlePrice;
  }
  document.addEventListener('change', function (e) {
    const r = e.target.closest('[data-bundle] input[type="radio"]');
    if (r) applyBundle(r);
  });
  function init() {
    document.querySelectorAll('[data-bundle] input[type="radio"]:checked').forEach(applyBundle);
  }
  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
})();
